/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";

// Images
import babLogo from "assets/images/BAB.jpg";
import ministereLogo from "assets/images/ministere.jpg";
import planningLogo from "assets/images/planning.png";
import agirLogo from "assets/images/Agir.jpg";
import ccafLogo from "assets/images/ccaf.jpg";
import maytonLogo from "assets/images/mayton.jpg";
import recapLogo from "assets/images/repac.jpg";
import calvifLogo from "assets/images/calvif.jpg";

// babLogo, ministereLogo, planningLogo, agirLogo, ccafLogo, maytonLogo, recapLogo, calvifLogo

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Soutenu par</MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            de nombreuses personnes engagées
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            BENINVI œuvre pour l’éducation, l’autonomie et l’émancipation des filles et des enfants au Bénin, avec le soutien d’acteurs engagés et partenaires.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Awa Tounkara"
              date="il y a 3 jours"
              review="Grâce au programme Awhilivou, j'ai appris à coder et à entreprendre. Aujourd’hui, je travaille sur mon propre projet ! Merci BENINVI."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="info"
              name="Binta Assogba"
              date="il y a 1 semaine"
              review="L’association m’a permis de continuer mes études et d'éviter un mariage forcé. Aujourd’hui, je suis autonome et j’aide d’autres filles à s’en sortir."
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Prosper Zinsou"
              date="il y a 2 semaines"
              review="Les initiatives de BENINVI ont transformé la vie de nombreux enfants en leur offrant une chance d’éducation et d’insertion professionnelle. Bravo !"
              rating={5}
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={babLogo} alt="BAB" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={ministereLogo} alt="Ministère" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={planningLogo} alt="Planning" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={agirLogo} alt="Agir" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={ccafLogo} alt="CCAF" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={maytonLogo} alt="Mayton" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={recapLogo} alt="Recap" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={calvifLogo} alt="Calvif" width="100%" opacity={0.6} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
